import React from 'react';
import axios from 'axios';
import { ChevronRight, Circle } from 'react-feather';
import {
  MdBackupTable,
  MdOutlineAssignment,
  MdOutlineReorder,
  MdOutlineSubtitles,
  MdOutlineTableRows,
} from 'react-icons/md';
import * as Icon from 'react-feather';
import styles from 'styles/Course.module.scss';
import classnames from 'classnames';
import FileDownload from 'js-file-download';
import { UNIT_STATUS, UNIT_TYPE } from 'constants/constants';
import dayjs from 'dayjs';
import { Spinner } from 'reactstrap';
import {
  showToastError,
  showToastInfo,
  showToastSuccess,
  showToastWarning,
} from '../@core/components/toastify/ToastTypes';
import { ENABLED_DETECT_PERMISSION, LOGGER_LEVEL } from '../config';
import { formatDDMMYYYY, formatHHmm, formatHHMMDDMM } from './format-time';
import { FiActivity, FiCopy, FiEdit, FiEdit2 } from 'react-icons/fi';
import unitsApi from 'api/unitsApi';
import { cmsPathName } from 'constants/header';
import Router from 'next/router';
import cartApi from 'api/cartApi';

import { AiOutlineMinus } from 'react-icons/ai';
import { BiCircle, BiMoviePlay } from 'react-icons/bi';
import { AiOutlineAudio, AiOutlineFileUnknown } from 'react-icons/ai';
import { FaRegFileAlt, FaRegImage } from 'react-icons/fa';
import { GoFileZip } from 'react-icons/go';
import Image from 'next/image';
import axiosClient from 'api/axiosClient';
import Swal from 'sweetalert2';

export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

export const shouldLoadMore = (scrollHeight, clientHeight, scrollTop) => {
  const bottomBorder = (scrollHeight - clientHeight) / 2;

  return bottomBorder < scrollTop;
};

export const getIconFromType = (type, isLiving = false, color = '#8E96AA') => {
  switch (type) {
    case UNIT_TYPE.LTI:
      return <Icon.Tv size={18} style={{ color }} />;
    case UNIT_TYPE.COMBINE_CLASS:
      if (isLiving) {
        return (
          <span className={classnames('flashit', styles['flashit'])}>
            <Icon.Radio color="#db0506" size={18} />
          </span>
        );
      } else {
        return <Icon.Crosshair size={18} style={{ color }} />;
      }
    case UNIT_TYPE.VIDEO:
      return <Icon.Video size={18} style={{ color }} />;
    case UNIT_TYPE.AUDIO:
      return <Icon.Mic size={18} style={{ color }} />;
    case UNIT_TYPE.CONTENT:
      return <Icon.BookOpen size={18} style={{ color }} />;
    case UNIT_TYPE.ASSIGNMENT:
      return <Icon.Calendar size={18} style={{ color }} />;
    case UNIT_TYPE.IFRAME:
      return <Icon.FileText size={18} style={{ color }} />;
    case UNIT_TYPE.SCORM:
      return <Icon.Inbox size={18} style={{ color }} />;
    case UNIT_TYPE.PRESENTATION:
      return <Icon.Monitor size={18} style={{ color }} />;
    case UNIT_TYPE.TEST:
      return <Icon.PenTool size={18} style={{ color }} />;
    case UNIT_TYPE.SURVEY:
      return <Icon.Twitch size={18} style={{ color }} />;
    case UNIT_TYPE.CLASSROOM:
      return <Icon.Clock size={18} style={{ color }} />;
    case UNIT_TYPE.LTI:
      return <Icon.Tv size={18} style={{ color }} />;
    case UNIT_TYPE.LIVESTREAMING:
    case UNIT_TYPE.MSTEAMS_MEETING:
      if (isLiving) {
        return (
          <span className={classnames('flashit', styles['flashit'])}>
            <Icon.Radio color="#db0506" size={18} />
          </span>
        );
      } else {
        return <Icon.Target size={18} style={{ color }} />;
      }
    case UNIT_STATUS.REVIEW:
      return <BiCircle color={'rgb(0 115 239)'} size={18} />;
    case UNIT_TYPE.FILES:
      return <Icon.Folder size={18} style={{ color }} />;
    case 'ARROW_RIGTH':
      return <ChevronRight style={{ color }} />;
    case UNIT_STATUS.COMPLETED:
    case 'GRADED':
      return <BiCircle color={'green' || color} size={18} />;
    case UNIT_STATUS.NOSTARTED:
    case UNIT_STATUS.RESUBMIT:
    case UNIT_STATUS.RESET:
      return <BiCircle color={color} size={18} />;
    case UNIT_STATUS.INPROGRESS:
    case 'IN_PROGRESS':
    case 'REATTEMPT':
      return <BiCircle color={'#e59819' || color} size={18} />;
    case UNIT_STATUS.FAILED:
    case UNIT_STATUS.INCOMPLETED:
      return <BiCircle color={'red' || color} size={18} />;
    default:
      return null;
  }
};

export const getIconForAction = {
  ADD: <Icon.Plus size={16} />,
  EDIT: <FiEdit />,
  CHANGE_NAME: <FiEdit2 />,
  DELETE: <Icon.Trash height={16} width={16} />,
  CLONE: <FiCopy />,
  VIEW: <Icon.Eye size={16} />,
  INACTIVE: <FiActivity />,
  ACTIVE: <AiOutlineMinus />,
  ADDLESSON: <MdOutlineAssignment />,
  ADDSECTION: <MdOutlineTableRows />,
  ADDSUBSECTION: <MdOutlineSubtitles />,
  ADDUNIT: <MdBackupTable />,
  SUBMISSION: <Icon.Book size={16} />,
  END_SESSION: <Icon.X size={16} />,
};

export const ContentIconArray = [
  [UNIT_TYPE.GROUP, { Icon: Icon.Layers, color: ['#589281'] }, 'Add Group'],
  [
    UNIT_TYPE.UNIT,
    { Icon: MdBackupTable, color: ['#FFA251', '#ffa25147'] },
    'Add Unit',
    [UNIT_TYPE.GROUP],
  ],
  [
    UNIT_TYPE.SECTION,
    { Icon: MdOutlineTableRows, color: ['#FF4365', '#ff436530'] },
    'Add Section',
    [UNIT_TYPE.UNIT],
  ],
  [
    UNIT_TYPE.SUB_SECTION,
    { Icon: MdOutlineSubtitles, color: ['#81B3FF', '#81b3ff52'] },
    'Add SubSection',
    [UNIT_TYPE.SECTION],
  ],
  [
    UNIT_TYPE.LESSON,
    { Icon: MdOutlineAssignment, color: ['#fc6c71', '#fc6c7145'] },
    'Add Lesson',
    [UNIT_TYPE.UNIT, UNIT_TYPE.SECTION, UNIT_TYPE.SUB_SECTION],
  ],
  ['Reorder', { Icon: MdOutlineReorder, color: ['#836ae7'] }, 'Reorder'],
  ['Clone_lessons', { Icon: Icon.Copy, color: ['#35cde5'] }, 'Clone lessons'],
];

export const countdownTimer = (milliSecond) => {
  const hours = Math.floor(
    (milliSecond % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((milliSecond % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((milliSecond % (1000 * 60)) / 1000);

  return { hours, minutes, seconds };
};

export const getNextUnit = (listUnits, currentUnitId) => {
  if (!listUnits) return -1;
  const indexCurrentUnit = listUnits.findIndex(
    (unit) => (unit?.unit ?? unit._id) === currentUnitId,
  );
  const listUnitAfterSlice = listUnits.slice(indexCurrentUnit + 1);
  const nextUnit = listUnitAfterSlice.find(
    (unit) => unit.type !== UNIT_TYPE.SECTION,
  );
  return nextUnit;
};

export const getPreviousUnit = (listUnits, currentUnitId) => {
  if (!listUnits) return -1;

  const indexCurrentUnit = listUnits.findIndex(
    (unit) => unit._id === currentUnitId,
  );

  const listUnitAfterSlice = listUnits.slice(0, indexCurrentUnit).reverse();

  const previousUnit = listUnitAfterSlice.find(
    (unit) => unit.type !== UNIT_TYPE.SECTION,
  );

  return previousUnit;
};

export const convertFileAudioOgg = (blob) =>
  new File([blob], `audio_${Date.now()}.ogg`, {
    type: 'audio/ogg',
  });

export const convertFileJPG = (blob) =>
  new File([blob], `SnapShot_${Date.now()}.jpg`, {
    type: 'image/jpeg',
    lastModified: Date.now(),
  });

export function downloadCertificate(endpoint, fileName) {
  return axios
    .get(endpoint, {
      responseType: 'blob',
    })
    .then((response) => {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName + '.jpg');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
}
export async function downloadFile(endpoint, fileName) {
  try {
    const response = await axios.get(endpoint, {
      responseType: 'blob',
    });

    if (response.status === 200) {
      FileDownload(response.data, fileName);
    } else {
      throw new Error('Failed to download file');
    }
  } catch (error) {
    throw new Error(`Error downloading file: ${error.message}`);
  }
}

export const handleToastError = async (
  error,
  translate,
  replace = undefined,
  showNormalMsg = false,
) => {
  console.error(error);

  if (error?.response?.data?.errors?.[0]?.msg) {
    const { type } = error?.response?.data?.errors?.[0];
    const msgType = {
      info: showToastInfo,
      error: showToastError,
      warning: showToastWarning,
      success: showToastSuccess,
    };
    const showToast = msgType[type] || msgType.error;
    showToast(error.response.data.errors[0].msg);

    if (
      error.response.data.errors[0].msg === 'PermissionDenied' &&
      typeof replace === 'function'
    ) {
      replace('/');
    }
  } else if (error?.response?.data && typeof error.response.data === 'string') {
    showToastError(error.response.data);
  } else if (error?.response?.data?.message) {
    showToastError(error.response.data.message);
  } else if (error?.response?.data?.error) {
    showToastError(error.response.data.error);
  } else if (error?.message) {
    showToastError(error.message);
  } else {
    showToastError(
      translate?.t('message.errorMessage') ||
        'An error occurred. Please try again.',
    );
  }
};

export const generateKey = (length) => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const sanitizeHtml = (html) => {
  if (typeof html !== 'string') return html;
  // Remove script tags and their contents
  let clean = html.replace(
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
    '',
  );
  // Remove inline event handlers (e.g., onerror, onload, onclick)
  clean = clean.replace(/\bon[a-z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^>\s]+)/gi, '');
  // Remove javascript: pseudo-protocols in href and src attributes
  clean = clean.replace(
    /\bhref\s*=\s*(?:"\s*javascript:[^"]*"|'\s*javascript:[^']*'|javascript:[^>\s]+)/gi,
    'href="#"',
  );
  clean = clean.replace(
    /\bsrc\s*=\s*(?:"\s*javascript:[^"]*"|'\s*javascript:[^']*'|javascript:[^>\s]+)/gi,
    'src=""',
  );
  return clean;
};

export const parseHtml = (content, className, style) => {
  if (!content) return <div />;
  const sanitized = sanitizeHtml(content);
  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};

export const stripHtml = (htmlString) => {
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');
  return doc.body.textContent || '';
};
export const formatQuery = (query) =>
  Object.keys(query)
    .map((key) => `${key}=${query[key]}`)
    .join('&');

export const showLevel = (count) => {
  let i = 0;
  let str = '';
  while (i < count) {
    str += '-';
    i += 1;
  }
  return `${str} `;
};

export const renderTimeView = (date) => {
  const currentTime = Date.now();
  const dateTime = new Date(date).getTime();
  if (currentTime - dateTime < 24 * 60 * 60 * 1000) {
    // a day
    return formatHHmm(date);
  }
  if (currentTime - dateTime < 30 * 24 * 60 * 60 * 1000) {
    // a month
    return formatHHMMDDMM(date);
  }
  if (date) {
    return formatDDMMYYYY(date);
  }
  return null;
};

export const wshowDurationTime = (time) => {
  const convertedSec = time * 60;
  const secNum = parseInt(convertedSec);
  const hours = Math.floor(secNum / 3600);
  const minutes = Math.floor((secNum - hours * 3600) / 60);
  const seconds = secNum - hours * 3600 - minutes * 60;
  let string = '';
  if (hours > 0) {
    string += `${hours}h`;
  }
  if (minutes > 0) {
    if (minutes < 10 && hours) {
      string += `0${minutes}m`;
    } else {
      string += `${minutes}m`;
    }
  }
  if (convertedSec === 0) {
    string += `${convertedSec}m`;
  }
  return string;
};

export const showDurationTime = (time) => {
  const secNum = parseInt(time);
  const hours = Math.floor(secNum / 3600);
  const minutes = Math.floor((secNum - hours * 3600) / 60);
  const seconds = secNum - hours * 3600 - minutes * 60;
  let string = '';
  if (hours > 0) {
    string += `${hours}h`;
  }
  if (minutes > 0) {
    if (minutes < 10 && hours) {
      string += `0${minutes}m`;
    } else {
      string += `${minutes}m`;
    }
  }
  if (seconds < 10 && !(hours === 0 && minutes === 0)) {
    string += `0${seconds}s`;
  } else {
    string += `${seconds}s`;
  }
  return string;
};

export const renderNumber = (number) => {
  if (number >= 0) {
    return number;
  }
  return (
    <>
      <Spinner size="sm" color="secondary" type="grow" />
      <Spinner size="sm" color="secondary" type="grow" />
      <Spinner size="sm" color="secondary" type="grow" />
    </>
  );
};

export const getIdRandom = () => `${Math.random().toString(36).substr(2, 9)}`;

export const accessCMS = (cms, pathname) => {
  let access = cms ? true : !cmsPathName.includes(pathname);
  !access && Router.push('/');
  return access;
};

export const syncGuestCartToBackend = async (userId) => {
  try {
    if (typeof window === 'undefined') return;
    const localCartStr = localStorage.getItem('cartItem');
    if (!localCartStr || localCartStr === '[]' || localCartStr === '') {
      return;
    }
    const localCart = JSON.parse(localCartStr);
    if (!Array.isArray(localCart) || localCart.length === 0) {
      return;
    }

    const backendCart = await cartApi.getCartDetailByUser(userId);

    for (const guestItem of localCart) {
      const guestCourseId = guestItem?._id;
      if (!guestCourseId) continue;

      // Find if this intake/course is already in backend cart
      const existingBackendItem = backendCart?.find(
        (item) => item?.course?._id === guestCourseId,
      );

      if (existingBackendItem) {
        // Merge units if both have specific units
        if (guestItem?.unitArray?.length) {
          const existingUnitIds =
            existingBackendItem?.units?.map((u) => u._id) || [];
          const guestUnitIds = guestItem.unitArray.map((u) => u._id);

          // Combine unique units
          const mergedUnitIds = Array.from(
            new Set([...existingUnitIds, ...guestUnitIds]),
          );

          // Map to find unit objects to calculate total price
          const allUnits = [
            ...(existingBackendItem?.units || []),
            ...(guestItem.unitArray || []),
          ];
          let mergedPrice = 0;
          const seen = new Set();
          allUnits.forEach((u) => {
            if (u?._id && !seen.has(u._id)) {
              seen.add(u._id);
              mergedPrice += parseInt(u.price || 0);
            }
          });

          const updatePayload = {
            ...existingBackendItem,
            course: existingBackendItem.course?._id,
            units: mergedUnitIds,
            price: mergedPrice,
          };
          await cartApi.update(existingBackendItem._id, updatePayload);
        } else {
          // If guest item is the whole intake, update backend item to be the whole intake too
          const updatePayload = {
            ...existingBackendItem,
            course: existingBackendItem.course?._id,
            units: [],
            price: guestItem?.price || existingBackendItem?.price || 0,
          };
          await cartApi.update(existingBackendItem._id, updatePayload);
        }
      } else {
        // Create new cart item on backend
        let param = {
          user: userId,
          course: guestCourseId,
          type: 'INTAKE',
          status: 'ACTIVE',
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        if (guestItem?.unitArray?.length) {
          param.units = guestItem.unitArray.map((u) => u._id);
          let guestPrice = 0;
          guestItem.unitArray.forEach((u) => {
            guestPrice += parseInt(u.price || 0);
          });
          param.price = guestPrice;
        } else {
          param.price = guestItem?.price || 0;
        }

        await cartApi.create(param);
      }
    }

    // Clear local storage cart
    localStorage.removeItem('cartItem');
  } catch (error) {
    console.error('Error syncing guest cart to backend:', error);
  }
};

export const hasPermission = (method, route, user, mode) => {
  if (!user?._id) return false;
  if (ENABLED_DETECT_PERMISSION && method && route) {
    if (
      user?.userType?.indexOf(
        mode
          ? `"method":"${method?.toUpperCase()}","route":"${route}","role":"${mode}"`
          : `"method":"${method?.toUpperCase()}","route":"${route}"`,
      ) !== -1
    ) {
      return true;
    }
    return false;
  }
  return true;
};

export const havePermissions = (permissions, user, mode) => {
  if (!user?._id) return false;
  if (ENABLED_DETECT_PERMISSION && permissions?.length) {
    let available = false;
    permissions?.map((item) => {
      if (
        user?.userType?.indexOf(
          mode
            ? `"method":"${item?.[0]?.toUpperCase()}","route":"${
                item?.[1]
              }","role":"${mode}"`
            : ` "method":"${item?.[0]?.toUpperCase()}","route":"${item?.[1]}"`,
        ) !== -1
      ) {
        available = true;
      }
    });
    return available;
  }
  return true;
};

export const getListTime = (interval, min, max) => {
  const x = interval; // minutes interval
  let times = []; // time array
  let tt = 0; // start time
  const ap = ['AM', 'PM']; // AM-PM

  // loop to increment the time and push results in array
  for (let i = 0; tt < 24 * 60; i++) {
    const hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
    const mm = tt % 60; // getting minutes of the hour in 0-55 format
    const apFormat = ap[Math.floor(hh / 12)];
    times[i] = {
      ap: apFormat,
      hours: hh,
      minutes: mm,
    }; // pushing data in array in [00:00 - 12:00 AM/PM format]
    tt += x;
  }

  if (!min && !max) {
    return times;
  }

  // if (min && max) {
  //   const index = times.findIndex((time) => {
  //     if (time.hours === dayjs(min).get('hour') && time.minutes === dayjs(min).get('minute')) {
  //       return true;
  //     }
  //     if (time.hours === dayjs(max).get('hour') && time.minutes === dayjs(max).get('minute')) {
  //       return true;
  //     }
  //   });
  //
  //   return times.slice(index + 1, times.length - 1);
  // }

  if (min) {
    const index = times.findIndex((time) => {
      if (
        time.hours === dayjs(min).get('hour') &&
        time.minutes === dayjs(min).get('minute')
      ) {
        return true;
      }
    });

    times = times.slice(index + 1, times.length - 1);
  }

  if (max) {
    const index = times.findIndex((time) => {
      if (
        time.hours === dayjs(max).get('hour') &&
        time.minutes === dayjs(max).get('minute')
      ) {
        return true;
      }
    });

    times = times.slice(0, index);
  }

  return times;
};

export const detectLinkify = (text) => {
  const urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  return text.replace(urlRegex, function (url) {
    return `<a href="${url}">${url}</a>`;
  });
};

export const formatNumeric = (number) => {
  const pr = new Intl.PluralRules('en-US', { type: 'ordinal' });

  const ordinals = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    many: 'th',
    zero: 'th',
    other: 'th',
  };

  return `${number}${ordinals[pr.select(number)]}`;
};

export const checkEmail = (value) => {
  let regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(value);
};
export const formatTimeHandler = (number) => {
  if (number < 1000) {
    return number.toString();
  } else {
    var result = number / 1000;
    return result % 1 === 0 ? result.toFixed(0) + 'k' : result.toFixed(1) + 'k';
  }
};

//  learning hrs cal
export const formatTimeHandlerHrs = (number) => {
  try {
    if (!number || number === '0s') return 0;
    const hours = number / 60;
    const result =
      hours > 1000 ? (hours / 1000).toFixed(2) + 'k' : hours.toFixed(2);
    return result;
  } catch (error) {
    console.error(error);
  }
};
export const NEXT_TYPE = {
  GROUP: 'units',
  UNIT: 'sections',
  SECTION: 'subSections',
};
export const NEXT_TYPE_LESSON = {
  GROUP: 'units',
  UNIT: 'unitLessons',
  SECTION: 'sectionLessons',
  SUB_SECTION: 'subSectionsLessons',
};

export function removeNullUndefined(obj, add = 'page') {
  let params = {
    ...obj,
  };
  for (const key in params) {
    if (
      params[key] === null ||
      params[key] === undefined ||
      params[key] === 'null' ||
      params[key] === 'undefined' ||
      params[key] === add
    ) {
      delete params[key];
    }
  }

  return params;
}

/**
 * Transforms a report object into an array of field-value-type mappings
 *
 * @param {Record<string, string | string[]>} reportObject - Object with field-value pairs
 * @param {Array<string>} [omitItems=[]] - Array of field names to omit from the transformation
 * @param {Array<[string, (val:  string) => any]>} [mapValues] - Optional map to apply transformations on specific fields
 * @returns {Array<{ field: string, type: string, value: Array<string | number> }>}
 */
export const transformedArray = (
  reportObject,
  omitItems = [],
  mapValues = [[]],
) => {
  try {
    omitItems.forEach((str) => delete reportObject[str]);

    const hasFields = new Map(mapValues);
    return Object.entries(reportObject).map(([field, value]) => {
      const [val, type = 'Equals'] = value.includes('~')
        ? value.split('~')
        : [value];
      let transformedValue = [];
      if (hasFields.has(field)) {
        transformedValue = hasFields.get(field)(val);
      } else if (val.includes(',')) {
        transformedValue = val.split(',');
      } else {
        transformedValue = [val];
      }

      return { field, type, value: transformedValue };
    });
  } catch (error) {
    console.log(error);
    return { field: '', type: '', value: [''] };
  }
};

export function extractTextFromHTML(html) {
  try {
    let tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Extract text and image file names
    let text = Array.from(tempDiv.childNodes)
      .map((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent.trim();
        } else if (node.nodeName === 'IMG') {
          // Extract the file name from the URL

          return node.src;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          return extractTextFromHTML(node.innerHTML);
        }
        return '';
      })
      .filter((item) => item)
      .join(' ');

    return text;
  } catch (error) {
    handleToastError(error);
  }
}

export const extractOnlyTextFromHTML = (html) => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = html;
  return tempElement.textContent || tempElement.innerText || '';
};

// const arrayDrill = (types = [], list, result, position) => {
//   types?.reduce((acc, curr, index) => {
//     if (acc.data.length) {
//       acc.data[position[types]] = {
//         [NEXT_TYPE[types]]:
//       };
//     } else {
//       return list;
//     }
//   }, 0);
// };

export const getFileIcon = (src, mimetype = '') => {
  const extension = src
    ? src.split('.').pop().split(/\#|\?/)[0].toLowerCase()
    : '';

  const SUPPORTED_IMAGE_FORMATS = ['gif', 'jpg', 'jpeg', 'png'];

  const videoExtensions = [
    'mp4',
    'webm',
    'ogg',
    'ogv',
    'avi',
    'mpeg',
    'mpg',
    'mov',
    'wmv',
    '3gp',
    'flv',
    'quicktime',
    'x-msvideo',
  ];
  const audioExtensions = [
    'mp3',
    'm4a',
    'aac',
    'wav',
    'wave',
    'ogg',
    'wma',
    'ra',
    'aif',
    'aiff',
  ];
  const documentExtensions = [
    'pdf',
    'doc',
    'docx',
    'ppt',
    'pptx',
    'xls',
    'xlsx',
    'txt',
  ];
  const archiveExtensions = ['zip'];

  let Icon = AiOutlineFileUnknown;
  let type = 'default';
  if (audioExtensions.includes(extension) && mimetype.includes('audio')) {
    Icon = AiOutlineAudio;
    type = 'AUDIO';
  } else if (videoExtensions.includes(extension)) {
    Icon = BiMoviePlay;
    type = 'VIDEO';
  } else if (documentExtensions.includes(extension)) {
    Icon = FaRegFileAlt;
    type = 'FILES';
  } else if (SUPPORTED_IMAGE_FORMATS.includes(extension)) {
    Icon = FaRegImage;
    type = 'IMAGE';
  } else if (archiveExtensions.includes(extension)) {
    Icon = GoFileZip;
    type = 'ZIP';
  }
  return { Icon, type, extension };
};

export function stripStylesAndClasses(htmlString, style) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  function removeStylesAndClasses(element) {
    element.removeAttribute('class');
    element.removeAttribute('style');

    // Create a style element to reset default styles
    const styleReset = {
      margin: '0',
      padding: '0',
      border: '0',
      outline: '0',
      background: 'transparent',
      'font-size': 'inherit',
      'font-weight': 'inherit',
      'font-family': 'inherit',
      'text-decoration': 'none',
      'vertical-align': 'baseline',
      ...style,
    };

    // Apply style reset
    Object.keys(styleReset).forEach((key) => {
      element.style[key] = styleReset[key];
    });

    // Recursively remove styles and classes from children
    Array.from(element.children).forEach((child) =>
      removeStylesAndClasses(child),
    );
  }

  // Apply the function to the body of the parsed document
  Array.from(doc.body.children).forEach((child) =>
    removeStylesAndClasses(child),
  );

  return doc.body.innerHTML;
}

/**
 * @param {any} data
 */

export function enCode(data) {
  let stringifyUrl = JSON.stringify(data);
  let encodeUrl = encodeURIComponent(stringifyUrl);

  const base64String = Buffer.from(encodeUrl).toString('base64');
  return base64String;
}

/**
 *
 * @param {string} text
 * @returns {any}
 */
export function deCode(text) {
  let decodedValue = null;
  if (text) {
    const decodedBuffer = Buffer.from(text, 'base64').toString();
    let decodeUrl = decodeURIComponent(decodedBuffer);
    decodedValue = JSON.parse(decodeUrl);
  }
  return decodedValue;
}

export function isValidObjectId(id) {
  // Regular expression to check for 24-character hexadecimal string
  return /^[a-f\d]{24}$/i.test(id);
}

/**
 * @param {Promise<Function>} deleteFn
 * @param {import('sweetalert2').SweetAlertOptions} options
 */

export const deleteSwal = async (deleteFn, options) => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to delete this?',
    icon: 'warning',
    showCancelButton: true,
    cancelButtonColor: 'secondary',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    ...options,
  });

  if (result.isConfirmed) {
    try {
      await deleteFn();
    } catch (error) {
      console.log(error);
      handleToastError(error);
    }
  }
};
